module.exports = __webpack_public_path__ + "img/kandanan.4bb677dd.png";